import useFetchService from '@/composables/useFetchService';

export default function useVideoService() {
  /********************
   * COMPOSITIONS      *
   ********************/
  const runtimeConfig = useRuntimeConfig();
  const fetchService = useFetchService({ base: runtimeConfig.public.apiUrl });

  /********************
   * FUNCTIONS         *
   ********************/
  function create(lang: string, data: any) {
    return fetchService.post('/videos/', lang, data);
  }

  function createVideo(lang: string, params: any) {
    return fetchService.get('/videos/upload/', lang, { params });
  }

  function getPreview(url: string, lang: string) {
    // Define regex to detect video URLs
    const youtubeRegex
      = /((?: https ?:) ?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu\.be))(\/(?:[\w-]+\?v=|embed\/|v\/)?)([\w-]{11})(\S+)?/;

    const vimeoRegex
      = /http(?:s?):\/\/(www\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^/]*)\/videos\/|)(\d+)(?:|\/\?)/;

    // Check for Youtube
    let result = url.match(youtubeRegex);
    if (result) {
      const videoId = result[5];
      return Promise.resolve(`https://img.youtube.com/vi/${videoId}/0.jpg`);
    }
    // Check for Vimeo
    result = url.match(vimeoRegex);
    if (result) {
      const videoId = result[3];
      return fetchService.get(`/videos/${videoId}/thumbnail/`, lang).then(response => response.url);
    }
    // Return fallback
    return Promise.resolve('https://img.youtube.com/vi/0.jpg');
  }

  function uploadVideo(url: string, lang: string, data: any, params = {}) {
    const headers = {
      'Tus-Resumable': '1.0.0',
      'Upload-Offset': '0',
      'Content-Type': 'application/offset+octet-stream',
      'Accept': 'application/vnd.vimeo.*+json;version=3.4',
    };
    return fetchService.patch(url, lang, data, { params, headers }, null, false);
  }

  return {
    create,
    createVideo,
    getPreview,
    uploadVideo,
  };
}
